import React, { useState, useEffect } from "react";
import moment from "moment";
import useTableScroll from "../../useTableScrollcesar";
import { formatMoneda, cmes } from "../../../util/varios";

const TableHistorico = (props) => {
  const liquidador = localStorage.getItem('liquidador')
  let op = require("../../../../src/modulos/datos");
  const [records, setRecords] = useState([]);
  const TIPO = {
    3: "1 QUINCENA",
    4: "2 QUINCENA",
  };

  const headCells = [
    { id: "periodo", label: "Periodo" },
    { id: "fecha", label: "Fecha Declaración" },
    { id: "montod", label: "Monto declarado" },
    { id: "monto", label: "Monto a pagar" },
    { id: "retenciones", label: "Credito y/o Descuento" },
    { id: "montop", label: "Monto pagado" },
    { id: "status", label: "Status" },
    { id: "detalles", label: "Detalles" },
  ];

  if (op.adjunto && op.nombre === "paez") {
    headCells.push({ id: "1", label: "IVA 1" });
    headCells.push({ id: "2", label: "IVA 2" });
  }

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const imprimirDjurada = (item) => (event) => {
    event.preventDefault();

    let idfactura;

    if (op.nombre === "paez" || op.nombre === "sigat") {
      idfactura = ` dj.idcomercio =${props.idcomercio} and dj.nummes =${item.nmes} and dj.anio =${item.nanio} and dj.tipo =${item.tipodecla}`;      
      const tipo = item.estatus === "Presentada/Oficina" || item.idfactura===null ? 9 : 1;
      window.open(
        `${op.reportespagoweb}FACTURA=${idfactura}&tipo=${tipo}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      const tipo = item.estatus === "Presentada/Oficina" || item.idfactura===null ? 9 : 1;
      if (tipo === 9) {
        idfactura = ` dj.idcomercio =${props.idcomercio} and dj.nummes =${item.nmes} and dj.anio =${item.nanio} and dj.tipo =${item.tipodecla}`;
      } else {
        idfactura = item.idfactura;
      }
      window.open(
        `${op.reportespagoweb}FACTURA=${idfactura}&tipo=${tipo}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };
  const imprimiriva1 = (idcom, nmes, nanio) => (event) => {
    event.preventDefault();

    const iva1 = `dm1-${idcom}-${cmes(nmes)}-${nanio}.pdf`;
    const url = op.conexionpagoweb + "/imagen?img=" + iva1;

    // Método 1: Verificación con fetch (para servidores modernos)
    const verificarConFetch = () => {
      return new Promise((resolve) => {
        fetch(url, {
          method: "HEAD",
          cache: "no-cache",
          mode: "no-cors",
        })
          .then((response) => {
            // Si no hay error de red, asumimos que el archivo existe
            resolve(true);
          })
          .catch((error) => {
            console.log("Fetch falló, probando método alternativo");
            resolve(verificarConImagen());
          });
      });
    };

    // Método 2: Verificación con imagen (para servidores antiguos)
    const verificarConImagen = () => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);

        // Forzar una petición única
        img.src = url + "?t=" + new Date().getTime();
      });
    };

    // Ejecutar verificación
    verificarConFetch().then((existe) => {
      if (existe) {
        window.open(
          url,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else {
        alert("No hay archivo disponible para este período");
      }
    });
  };

  const imprimiriva2 = (idcom, nmes, nanio) => (event) => {
    event.preventDefault();
    let iva1 = `dm2-${idcom}-${cmes(nmes)}-${nanio}.pdf`;
    window.open(
      op.conexionpagoweb + "/imagen?img=" + iva1,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  useEffect(() => {
    setRecords(props.post);
  }, [props.post]);

  return (
    <TblContainer
      container={{
        maxHeight: 300,
        width: "100%",
        overflow: "auto",
      }}
    >
      <TblHead />
      <tbody>
        {records &&
          records.map((post1, index) => (
            <tr key={index} style={{ padding: "0" }}>
              <td>
                {post1.cmes +
                  "/" +
                  post1.nanio +
                  " " +
                  (TIPO[post1.tipodecla] || "")}
              </td>
              <td style={{ textAlign: "center", padding: "0" }}>
                {moment.utc(post1.fechadecla).format("DD/MM/YYYY")}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatMoneda(
                  post1.montodecla.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatMoneda(
                  post1.montopagar.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatMoneda(
                  post1.credifavor.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
              </td>
              <td style={{ textAlign: "right" }}>
                {post1.totalapagar < 0
                  ? "0,00"
                  : formatMoneda(
                      post1.totalapagar.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
              </td>
              <td
                style={{
                  color:
                    post1.status === 0
                      ? "rgb(255, 0, 0)"
                      : post1.status === 2
                        ? "rgb(0, 0, 255)"
                        : "rgb(0, 0, 0)",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {post1.estatus}
              </td>
              <td>
                {
                  <button
                    onClick={imprimirDjurada(post1)}
                    className="btn btn-block btn-danger btn-xs"
                  >
                    <i className="fas fa-file-pdf"></i>{" "}
                  </button>
                }
              </td>
               {(op.adjunto && (post1.tipodecla === 4 || post1.tipodecla === 2)) && (
                <td>
                  <button
                    onClick={imprimiriva1(
                      props.idcomercio,
                      post1.nmes,
                      post1.nanio,
                    )}
                    className="btn btn-block btn-danger btn-xs"
                  >
                    <i className="fas fa-file-pdf"></i>{" "}
                  </button>
                </td>
              )}
               {(op.adjunto && (post1.tipodecla === 4 || post1.tipodecla === 2)) && (
                <td>
                  <button
                    onClick={imprimiriva2(
                      props.idcomercio,
                      post1.nmes,
                      post1.nanio,
                    )}
                    className="btn btn-block btn-danger btn-xs"
                  >
                    <i className="fas fa-file-pdf"></i>{" "}
                  </button>
                </td>
              )}
            </tr>
          ))}
      </tbody>
    </TblContainer>
  );
};

export default TableHistorico;
